import { axiosInstance } from '../base.api';
import { paths } from '../paths';
import {
  KinSimCampaignDetailsType,
  SerivceKinSimUrlsDetailsType,
  ServiceKinSimCampaignsType,
  ServiceKinSimUrlsRequestType,
  ServiceKinSimUrlsResponseType
} from '../type/service.type';

export const serviceIssuseKinSim = async ({
  service_id,
  guest_id,
  campaign_id,
  quantity
}: ServiceKinSimUrlsRequestType): Promise<ServiceKinSimUrlsResponseType> => {
  const item = await axiosInstance.post(paths.serviceIssuseKinSim(service_id), {
    guest_id,
    campaign_id,
    quantity
  });
  return item.data.data;
};

export const serviceGetKinSimCampaigns = (): Promise<{ data: ServiceKinSimCampaignsType[] }> => {
  return axiosInstance.get(paths.serviceGetKinSimCampaigns()).then(item => item.data.data);
};

export const serviceGetKinSimUrls = (
  service_id: number
): Promise<{ data: SerivceKinSimUrlsDetailsType }> => {
  return axiosInstance.get(paths.serviceGetKinSimUrls(service_id)).then(item => item.data.data);
};

export const getKinSimCampaignDetails = (
  campaign_id: number
): Promise<{ data: KinSimCampaignDetailsType }> => {
  return axiosInstance
    .get(paths.getKinSimCampaignDetails(campaign_id))
    .then(item => item.data.data);
};
